import { TipRepository } from "../../../repositories/tipRepository"
import { UseCase } from "../../useCase"
import { DeleteCountryTipRequest } from "./request"
import { DeleteCountryTipResponse } from "./response"

export class DeleteCountryTipUseCase implements UseCase<DeleteCountryTipRequest, DeleteCountryTipResponse> {
	private _repository

	constructor({ TipRepository }: { TipRepository: TipRepository }) {
		this._repository = TipRepository
	}

	exec({ tipId, countryId }: DeleteCountryTipRequest) {
		return this._repository.deleteCountryTip(tipId, countryId)
	}
}
